import axios from 'axios';
export {attachmentsVehicleActions};

axios.defaults.withCredentials = true

function attachmentsVehicleActions() {
    const baseUrl = ``;
    const tenantVal = `${process.env.REACT_APP_TENANT}`;
  
    return {
        vehicleAttachmentById,
        downloadFileAttachment,
        createAttachmentVehicle,
        updateAttachmentVehicle,
        deleteAttachmentVehicle,
        exportData,

    }

    async function vehicleAttachmentById(tenant:string,vehicleId:any,pageNumber:number,pageSize:number){      
        return   axios.get(`${baseUrl}/masterdatavehicle/vehicleattachment/vehicle/${vehicleId}`,{
                params:
                {   tenant:tenant,
                    pageNumber:pageNumber,
                    pageSize:pageSize,
                }
            })
    }
    async function downloadFileAttachment(tenant:string,id:number){
        return axios.get(`${baseUrl}/masterdatavehicle/vehicleattachment/${id}/file`,
       { params:{tenant:tenant},
        responseType:'blob'as 'json'
    })
    }

    async function updateAttachmentVehicle(tenant:string,vehicleAttachmentId:number,atachment:any){      
        return   axios.put(`${baseUrl}/masterdatavehicle/vehicleattachment/${vehicleAttachmentId}`,atachment,{ params:{tenant:tenant}}
        )
    }

    async function createAttachmentVehicle(tenant:string,vehicleId:number,description:any,file:any){      
        return   axios.post(`${baseUrl}/masterdatavehicle/vehicleattachment/file/${vehicleId}`,file,{
            params:{
                tenant:tenant,
                description:description},
            headers:{
                'content-type': 'multipart/form-data'
           }
         }
        
        )
    }

    async function deleteAttachmentVehicle(tenant:string,vehicleAttachmentId:number){      
        return   axios.delete(`${baseUrl}/masterdatavehicle/vehicleattachment/${vehicleAttachmentId}`,{ params:{tenant:tenant}}
        )
    }

    async function exportData(tenant:string,id:any){ 
        return   axios.get(`${baseUrl}/masterdatavehicle/vehicleattachment/${id}/excel`,
               {params:{tenant:tenant},
                responseType: 'arraybuffer',})
    }
}
